import { I18n } from 'react-redux-i18n'

import { isValidText } from '../../../utils/helpers'
import { MARKETING } from '../../../constants'

const providersValues = Object.values(MARKETING.providers)

const checkRequiredFields = ({ fields, validation, template }) => {
  const invalidFields = {}

  fields && fields.forEach(field => {
    if (validation[field]?.required && (!template[field] || !isValidText(template[field]))) {
      invalidFields[field] = I18n.t('dashboard_errors_required-field')
    }
  })

  return invalidFields
}

export default (template, allowToSave) => {
  const channel = template.channel
  const validation = providersValues.find((v) => v.channels.includes(channel)).validation

  const errors = checkRequiredFields({ fields: ['name', 'subject'], validation, template })

  if (!allowToSave) if (validation.content.required && (!template.content || !isValidText(template.content))) errors.content = I18n.t('error_template_content')

  if (validation.content.limit < template.content.length) errors.content = `This field must be lower than ${validation.content.limit} characters.`

  return errors
}
